import React, { createContext, useContext, useState } from "react";

const EditLockContext = createContext();

export const EditLockProvider = ({ children }) => {
  const [lockMode, setLockMode] = useState(null); // null | 'crop' | 'rotate'

  const lock = (mode) => setLockMode(mode);
  const unlock = () => setLockMode(null);

  return (
    <EditLockContext.Provider
      value={{
        isLocked: !!lockMode,
        mode: lockMode,
        lock,
        unlock,
      }}>
      {children}
    </EditLockContext.Provider>
  );
};

export const useEditLock = () => useContext(EditLockContext);
